import {
  GET_SHORTLIST_DETAILS,
  GET_SHORTLIST_DETAILS_SUCCESS,
  GET_SHORTLIST_DETAILS_FAIL,
  GET_SHORTLIST_MANAGERS_LIST,
  GET_SHORTLIST_MANAGERS_LIST_FAILED,
  GET_SHORTLIST_MANAGERS_LIST_SUCCESS,
  CHANGE_SHORTLIST_MANAGER,
  CHANGE_SHORTLIST_MANAGER_SUCCESS,
  CHANGE_SHORTLIST_MANAGER_FAILURE,
  UPDATE_SHORTLIST_DETAILS,
  UPDATE_SHORTLIST_DETAILS_SUCCESS,
  UPDATE_SHORTLIST_DETAILS_FAIL,
} from "./actionTypes";

export const getShortlistDetails = (jobId, candidateId) => ({
  type: GET_SHORTLIST_DETAILS,
  payload: { jobId, candidateId },
});

export const getShortlistDetailsSuccess = (shortlistDetails) => ({
  type: GET_SHORTLIST_DETAILS_SUCCESS,
  payload: shortlistDetails,
});

export const getShortlistDetailsFail = (error) => ({
  type: GET_SHORTLIST_DETAILS_FAIL,
  payload: error,
});

export const getShortlistManagersList = (jobid) => {
  return {
    type: GET_SHORTLIST_MANAGERS_LIST,
    payload: { jobid },
  };
};

export const getShortlistManagerSuccess = (data) => {
  return {
    type: GET_SHORTLIST_MANAGERS_LIST_SUCCESS,
    payload: { data },
  };
};

export const getShortlistManagerFailed = (error) => {
  return {
    type: GET_SHORTLIST_MANAGERS_LIST_FAILED,
    payload: { error },
  };
};
export const changeShortListManager = (data) => {
  return {
    type: CHANGE_SHORTLIST_MANAGER,
    payload: { data },
  };
};

export const changeShortListManagerSuccess = (success) => {
  return {
    type: CHANGE_SHORTLIST_MANAGER_SUCCESS,
    payload: { success },
  };
};

export const changeShortListManagerFailed = (error) => {
  return {
    type: CHANGE_SHORTLIST_MANAGER_FAILURE,
    payload: { error },
  };
};

export const updateShortlistDetails = (data) => ({
  type: UPDATE_SHORTLIST_DETAILS,
  payload: data,
});

export const updateShortlistDetailsSuccess = (success) => ({
  type: UPDATE_SHORTLIST_DETAILS_SUCCESS,
  payload: success,
});

export const updateShortlistDetailsFail = (error) => ({
  type: UPDATE_SHORTLIST_DETAILS_FAIL,
  payload: error,
});
